import axiosJava from "@/api/config_java";
//导出
export const exportData = param =>
  axiosJava.get(`/am/api/accountInfo/export?${param}`, {
    responseType: "blob"
  });

// facebook封户折线图
export const closeTrend = param => axiosJava.get(`/am/api/accountClose/closeTrend`,  { params: param });
// facebook封户趋势数据列表
export const closeTrendList = param => axiosJava.get(`/am/api/accountClose/closeTrendList`, { params: param });
// facebook封户趋势数据列表 详情-单个开户公司数据
export const closeAccountCompany = param => axiosJava.get(`/am/api/accountClose/closeAccountCompany`, { params: param });
// facebook封户趋势数据列表 详情-开户公司所有的封户数据
export const closeAccountInfoList = param => axiosJava.get(`/am/api/accountClose/closeAccountInfoList`, { params: param });

// facebook封户折线图
export const adlarrTrend = param => axiosJava.get(`/am/api/adlarr/trend`, { params: param });
// facebook封户趋势数据列表
export const adlarrTrendList = param => axiosJava.get(`/am/api/adlarr/trendList`, { params: param });
// facebook封户趋势数据列表 详情-单个开户公司数据
export const larrAccountCompany = param => axiosJava.get(`/am/api/adlarr/larrAccountCompany`, { params: param });
// facebook封户趋势数据列表 详情-开户公司所有的封户数据
export const larrAccountInfoList = param => axiosJava.get(`/am/api/adlarr/larrAccountInfoList`, { params: param });

